@if(attachmentFiles.length){
<p class="font-semibold text-sm text-[#18191C] " style="margin: 10px;">Attachments ({{attachmentFiles.length}})</p>
}
<div *ngFor="let attachment of attachmentFiles; let i = index;"
    class="flex rounded bg-white justify-between p-3 my-1.5 mx-3" style="border: 1px solid rgba(211, 220, 232, 0.7);">
    <div class="flex">
        <div style="position: relative;top: 4px;">
            <file-extension [IconName]="getFileExtension(attachment.display_file_name)" [isActive]="true">
            </file-extension>
        </div>
        <p style="line-height: 32px !important;margin-left: 4px !important;"
            class="font-semibold m-0 text-sm text-[#18191C]">{{attachment.display_file_name}}</p>
    </div>
    <div class="flex  ">
        <button  (click)="deleteAttachment(index,attachment.id,attachment.display_file_name)" attachment
            class="bg-[#EBF0FA] p-0 mx-2	cursor-pointer  h-8  w-8 rounded-[100px] text-[#25508e]">
            <mat-icon style="font-size: 16px;
                position: relative;
                line-height: 30px;">close</mat-icon>
        </button>
        <button  (click)="downloadAttachment(attachment.id, attachment.display_file_name)"
            class="bg-[#25508e] cursor-pointer font-semibold rounded text-xs text-white px-6 py-2">
            Download
        </button>


    </div>
</div>
@if(attachmentFiles.length >0){
<mat-divider [class]="'m-4'"></mat-divider>

}